var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FeedbackModal, } from '../feeback-modal/feedback-modal';
import { Box, Button, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog';
import FeedbackIcon from '@mui/icons-material/Announcement';
import axios from 'axios';
export var FeedbackState;
(function (FeedbackState) {
    FeedbackState[FeedbackState["CLOSED"] = 0] = "CLOSED";
    FeedbackState[FeedbackState["NEW"] = 1] = "NEW";
    FeedbackState[FeedbackState["SUBMITTING"] = 2] = "SUBMITTING";
    FeedbackState[FeedbackState["COMPLETED"] = 3] = "COMPLETED";
    FeedbackState[FeedbackState["FAILED"] = 4] = "FAILED";
})(FeedbackState || (FeedbackState = {}));
var onSubmitFeedback = function (feedbackServiceUrl, tokenProvider, segment, opco, feedback, collectMetadata) { return __awaiter(void 0, void 0, void 0, function () {
    var deviceInfo, token, metadata, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                deviceInfo = {
                    screenWidth: window.screen.availWidth,
                    screenHeight: window.screen.availHeight,
                    orientation: (_a = window.screen.orientation) === null || _a === void 0 ? void 0 : _a.type,
                };
                return [4 /*yield*/, tokenProvider()];
            case 1:
                token = _b.sent();
                metadata = {};
                if (!collectMetadata) return [3 /*break*/, 3];
                return [4 /*yield*/, collectMetadata()];
            case 2:
                metadata = _b.sent();
                _b.label = 3;
            case 3:
                _b.trys.push([3, 5, , 6]);
                return [4 /*yield*/, axios.post("".concat(feedbackServiceUrl, "/feedback"), {
                        description: feedback.description,
                        feedbackType: feedback.feedbackType,
                        email: feedback.optInEmail,
                        segment: segment,
                        opco: opco,
                        contentUrl: window.location.href,
                        deviceInfo: deviceInfo,
                        metadata: metadata,
                    }, {
                        headers: {
                            'content-type': 'application/json',
                            'authorization': "Bearer ".concat(token),
                        },
                    })];
            case 4:
                _b.sent();
                return [3 /*break*/, 6];
            case 5:
                error_1 = _b.sent();
                return [2 /*return*/, false];
            case 6: return [2 /*return*/, true];
        }
    });
}); };
export var Feedback = function (_a) {
    var feedbackServiceUrl = _a.feedbackServiceUrl, tokenProvider = _a.tokenProvider, collectMetadata = _a.collectMetadata, segment = _a.segment, opco = _a.opco, texts = _a.texts, customButton = _a.customButton, buttonTextTransform = _a.buttonTextTransform, buttonSize = _a.buttonSize, trackAnalytics = _a.trackAnalytics, onModalClose = _a.onModalClose, userEmail = _a.userEmail, selectDisplayEmpty = _a.selectDisplayEmpty;
    var _b = useState(FeedbackState.CLOSED), feedbackState = _b[0], setFeedbackState = _b[1];
    var _c = useState(), submittableTicket = _c[0], setSubmittableTicket = _c[1];
    var openModal = useCallback(function () {
        setFeedbackState(FeedbackState.NEW);
    }, [setFeedbackState]);
    var sendFeedback = useCallback(function (feedback) {
        setSubmittableTicket(feedback);
        setFeedbackState(FeedbackState.SUBMITTING);
    }, []);
    useEffect(function () {
        if (feedbackState === FeedbackState.SUBMITTING && submittableTicket !== undefined) {
            onSubmitFeedback(feedbackServiceUrl, tokenProvider, segment, opco, submittableTicket, collectMetadata).then(function (success) {
                setSubmittableTicket(undefined);
                setFeedbackState(success ? FeedbackState.COMPLETED : FeedbackState.FAILED);
                if (onModalClose)
                    onModalClose();
            });
        }
    }, [onSubmitFeedback, feedbackState]); // eslint-disable-line react-hooks/exhaustive-deps
    var modalClosed = useCallback(function () {
        setFeedbackState(FeedbackState.CLOSED);
        if (onModalClose)
            onModalClose();
    }, [setFeedbackState]); // eslint-disable-line react-hooks/exhaustive-deps
    var MessageBox = function () {
        switch (feedbackState) {
            case FeedbackState.COMPLETED:
                return (_jsx(ConfirmationDialog, { texts: {
                        title: texts.confirmationTitle,
                        description: texts.confirmationMessage,
                        confirmationLabel: texts.confirmationClose,
                    }, buttonTextTransform: buttonTextTransform, buttonSize: buttonSize, onAccept: modalClosed, onClose: modalClosed, open: true }));
            case FeedbackState.FAILED:
                return (_jsx(ConfirmationDialog, { texts: {
                        title: texts.sendFailureTitle,
                        description: texts.sendFailureMessage,
                        confirmationLabel: texts.confirmationClose,
                    }, buttonTextTransform: buttonTextTransform, buttonSize: buttonSize, onAccept: modalClosed, onClose: modalClosed, open: true }));
            default:
                return null;
        }
    };
    return (_jsxs(_Fragment, { children: [customButton ? (_jsx(Box, __assign({ onClick: openModal }, { children: customButton }))) : (_jsx(Button, __assign({ startIcon: _jsx(FeedbackIcon, {}), onClick: openModal, disabled: feedbackState !== FeedbackState.CLOSED, sx: {
                    color: '#333333',
                } }, { children: _jsx(Typography, __assign({ variant: "button" }, { children: texts.feedbackButtonText })) }))), feedbackState !== FeedbackState.CLOSED && feedbackState !== FeedbackState.COMPLETED && (_jsx(FeedbackModal, { onSubmit: sendFeedback, onClose: modalClosed, loading: feedbackState === FeedbackState.SUBMITTING, buttonTextTransform: buttonTextTransform, buttonSize: buttonSize, texts: texts.feedbackModalTexts, trackAnalytics: trackAnalytics, userEmail: userEmail, selectDisplayEmpty: selectDisplayEmpty })), _jsx(MessageBox, {})] }));
};
